import { layoutRouter } from "./layoutRouter";
import Login from "../pages/auth/login/Login";
import Error403 from "../pages/errors/Error403";
import Error404 from "../pages/errors/Error404";
import Error500 from "../pages/errors/Error500";
import PrivacyPolicy from "../pages/privacy-policy/PrivacyPolicy";
import ContactUs from '../pages/contact-us/ContactUs';

export const indexRouter: any = [
  // { path: "/", element: <RootPage></RootPage> },
  { path: "login", element: <Login /> },
  layoutRouter,
  { path: "/policy", element: <PrivacyPolicy/>},
  { path: "/contact", element: <ContactUs/>},

  { path: "not-permission", element: <Error403/>},
  { path: "*", element: <Error404/>},
  { path: "under-maintenance", element: <Error500/>},
];
